
export const ENVESTNET_YODLEE = "Yodlee";

export const SEARCH = "Search";
export const DASHBOARD = "Dashboard";
export const SUPPORT = "Support";
export const SERVICE_REQUESTS = "Service requests";
export const USERS = "Users";
export const SITES = "Sites";
export const USER = "User";
export const INSTITUTIONS = "Institutions";
export const NOTIFICATIONS = "Notifications";
export const COUNTRIES = "Counties";
export const ANALYTICS = "Analytics";
export const USAGE = "Usage";
export const SUCCESS = "Success";
export const ENGAGEMENT = "Engagement";
export const DEMOGRAPHICS = "Demographics";
export const CONFIGURATIONS = "Configurations";
export const PRODUCTS = "Products";
export const CERTIFICATES = "Certificates";
export const SETTINGS = "Settings";
export const PERMISSIONS = "Permissions";
export const GROUP_PERMISSIONS = "Group permissions";
export const SYSTEM_SETTINGS = "System Settings";
export const HELP = "Help";
export const MY_ACCOUNT = "My account";
export const Questions = "Questions?";

export const CLOSE = "Close";
export const SUPPORT_GROUPS = "Support groups";
export const MANAGE_TAG = "Manage tag";
export const MANAGE_ROLES = "Manage role permissions";
export const TROUBLESHOOT = "Troubleshoot";
export const ACCOUNT = "Account";
export const CREATE = "Create";
export const ALL_CUSTOMERS = "All customers";
export const VIEWING = "Viewing";
export const SPLASH = "Replay Features";
export const CUSTOMERS = "Customers";
export const STATUS = "Status";
export const REQUEST_NEW_SITE_SUPPORT = "Request new site support";
export const PROFILE = "Profile";
export const SIGN_OUT = "Sign out";
export const SELECT_ROLE = "Select Role";
export const VIEW_INSIGHTS_FOR = "View Insights for";
export const MANAGEMENT_REPORTING = "Product Health & Reporting";
export const FASTLINK_JOURNEY_ANALYTICS = "FastLink Journey Analytics";
export const AGGREGATION = "Aggregation Health";
export const VERIFICATION = "Verification Health";
export const DEVELOPER_CHAT = "Developer Chat";
export const SMB = "SMB";
export const ATV = "ATV";
